import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonPage,
  IonBackButton,
  IonButtons,
} from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import { useLocation, useParams } from "react-router-dom";
import { decodeParam, encodeParam } from "../util/ApiHelper";
import ShareWorkOrderButton from "../components/ShareWorkOrderButton";
import "./TabPage.css";

interface TabPageProps {
  content?: any;
  title?: string;
  altHeaderTitle?: string;
  route?: string;
  // Show the work-order share control in the trailing slot (US 379069, FR-7).
  // Opt-in per route so only the WO Details tabs get it — the other tabs that
  // reuse this page (Long Description, Resources, …) stay unaffected.
  showShare?: boolean;
}

const TabPage: React.FC<TabPageProps> = (props) => {
  const { workOrderId } = useParams<{ workOrderId: string }>();
  let displayWo = decodeParam(workOrderId);
  const location = useLocation();
  const { title, content, altHeaderTitle, showShare } = props;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref={`${location.pathname.includes("requester") ? "/requester" : ""}/workorder/${encodeParam(displayWo)}`}
              icon={chevronBackOutline}
            />
          </IonButtons>
          <IonTitle class="tab-page-title">
            {altHeaderTitle ? altHeaderTitle : displayWo} - {title || ""}
          </IonTitle>
          {showShare && <ShareWorkOrderButton woNumber={displayWo} />}
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>{content}</IonContent>
    </IonPage>
  );
};

export default TabPage;
